function accordion(name) {
  var accordionHeader = $(name + " " + name + "-item-header");
  var accordionContent = $(name + " " + name + "-item-content");
  $(accordionContent).hide();
  $(accordionContent).first().show();
  $(accordionHeader).first().addClass('active');
  $(accordionHeader).on('click', function (e) {
    var accContent = $(accordionContent);
    var $this = $(this);
    if ($this.next().is(":visible")) {
      accContent.slideUp();
      $this.removeClass('active');

    } else {
      $(accordionHeader).removeClass('active');
      accContent.slideUp();
      $this.addClass('active');
      $this.next(name + " " + name + "-item-content").slideDown();
    }
  });
}

$(function () {
  accordion(".js-accordion");
})

$(".js-accordion").click(function () {
  $(this).next().slideToggle();
  $(this).toggleClass("accordion-open");
});